export default __webpack_public_path__ + "static/media/admin-orders.d823acd2.svg";